module.exports = __webpack_public_path__ + "media/images/flags/32/Guinea-0171426bae17f09c257238eba8ad9532.png";